import type { FaireProductEntity } from "../../entity_types/product";

export const p_rraw8haxzs: FaireProductEntity = {
  token: "p_rraw8haxzs",
  type: "product",
  name: "Spice and Wolf, Vol. 13",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/ce5574845ea32ad1c9523da0f209db2359dcce7434744d0a9f073a1005f57df7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4a0d5855e16f2b40be296bc8bc9ff08c0e7789c037f70b80c1ffa4ffe4bca75.webp"
  ],
  priceDollars: 6.5,
  description: "Parental Advisory: Explicit Content Warning\n\nLawrence and Holo draw ever closer to the wisewolf's homeland of Yoitsu. But as they near the final leg of their journey, the two of them hear about a mercenary band that shares its name with one of Holo's oldest companions, Myuri. Their investigation brings them to the astonishingly prosperous town of Lesko, a place seemingly overflowing with opportunity and success. But Lawrence has never heard of a town that has no walls or tariffs. How could this be? More importantly, what connections do the Myuri mercenary band have with Lesko's masters, the mighty Debau Company? This manga adaptation of Isuna Hasekura's acclaimed Spice & Wolf novel series, available from Yen On, is an investment that promises the greatest of entertainment returns!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:37.733Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
